__turbopack_context__.v({
  "content": "ArticleModuleHero-module-scss-module__cHojSq__content",
  "metadataBox": "ArticleModuleHero-module-scss-module__cHojSq__metadataBox",
  "wrapper": "ArticleModuleHero-module-scss-module__cHojSq__wrapper",
});
